import React from "react"
import Helmet from "react-helmet"
import styles from "../styles/contact.module.scss"
import mailIcon from "../../images/email-filled-closed-envelope.png"
import twIcon from "../../images/twitter-logo-silhouette.png"
import Board from "../components/board.js"

export default ({data}) =>
  <div>
  	<Helmet
      title={`Contact | ${data.site.siteMetadata.title}`}
    />
  	<Board>
  		<h3>お問い合わせ先</h3>
		<table>
			<tbody>
				<tr>
					<th><img src={mailIcon}/></th>
			  		<td>karuhiko1+mingaku@gmail.com</td>
				</tr>
				<tr>
					<th><img src={twIcon}/></th>
					<td><a href="https://twitter.com/karuhiko1" target="__blank">@karuhiko1</a></td>
				</tr>
			</tbody>
		</table>
    </Board>
  </div>


export const query = graphql`
  query contactQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/contact.js